import React, { useContext, useRef } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import PaymentOrdersGrid from './PaymentOrdersGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import usePaymentOrdersPresenter from './PaymentOrdersPresenter';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const { selectedSupplier, setSelectedSupplier, dateFrom, setDateFrom, dateTo, setDateTo, validateAndSearch, cleanFilters } = filtersProps;

  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <CustomDatePicker value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const PaymentOrdersWithholdings = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, ...filtersProps } = usePaymentOrdersPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <PaymentOrdersGrid data={rows} tableRef={tableRef} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default PaymentOrdersWithholdings;
